import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../services/store/userSlice';
import { SplitButton } from 'primereact/splitbutton';
import FileSaver from "file-saver";
import ContactInfo from './profile_contactInfo';
import ProfileHeading from './profile_heading';
import ProfileSkill from './profile_skills/skill';
import '../../extentions/style.css';
import { Dialog } from 'primereact/dialog';
import './style.css';
import ProfileCertification from './profile_certification/certification';
import ProfileEducation from './profile_education/education';
import ProfileProject from './profile_project/project';
import properties from '../../../config/environmentProperties';
import { contactService, professionalService } from '../../../services/profile';
import { useEffect } from 'react';
import { userService } from '../../../services/extensions';
import ShareLinkForm from './share_link_form';
import { toast } from 'react-toastify';
import PrimarySkill from './profile_primaryskill/primaryskill';
import { userProfilePicture } from '../../../services/common/states';


const Profile = ({ calculateOvRating }) => {
    const user = useSelector(selectUser);
    const [shareDia, setShareDia] = useState(false);
    const [allUsersEmail, setAllUsersEmail] = useState([]);
    const [emailPayload, setEmailPayload] = useState('');
    const resPath = properties.currentEnvironment.docPath + 'resumes/';

    let count = 0;
    const [userProfileDetails, setUserProfileDetails] = useState([]);
    const onShow = () => {
        getAllUsers();
        setShareDia(true);
    }
    useEffect(() => {
        if (count === 0) {
            count++;
            getUserProfileDetailsById();
        }
    }, []);

    const getUserProfileDetailsById = () => {
        professionalService.getUserProfileDetails(user.id).then((resp) => {
            try {
                setUserProfileDetails(resp.data.data);
                userProfilePicture.next(resp?.data?.data?.photo);
                calculateOvRating()
            } catch (error) {
                // Error handle
            }
        });
    };
    const downloadResume = () => {
        contactService.downloadResume().then((resp) => {
            try {
                var blob = new Blob([resp.data], {
                    type: "application/pdf",
                });
                FileSaver.saveAs(blob, `Resume.pdf`);
            } catch (error) {
                // Error handle
            }
        });
    }

    const item = [
        { label: 'Download Resume', icon: 'pi pi-file-pdf', command: () => { downloadResume(); } }
    ];

    const getAllUsers = () => {
        userService.getAllUsers().then((resp) => {
            setAllUsersEmail(resp.data.data);
        });
    };

    const mailIdList = (data) => {
        let emailInString = data.toString();
        let emailFormat = emailInString.replace(",", ";");
        setEmailPayload(emailFormat);
    };

    const saveData = () => {
        sendAsMail();
    };

    const sendAsMail = () => {
        var param = { "email": emailPayload }
        contactService.sendEmail(param).then((resp) => {
            try {
                setShareDia(false);
                toast.info("Mail sent successfully!");
            } catch (error) {
                // Error handle
            }
        });
    };

    const ShareScreenDialog = () => {
        return (
            <div className="flex align-items-center flex-column px-3">
                <Dialog header="Share Profile" visible={shareDia} style={{ width: '500px' }} onHide={() => setShareDia(false)} >
                    <ShareLinkForm save={(data) => saveData(data)} onClose={() => setShareDia(false)} allUsersEmail={allUsersEmail} mailIdListProp={mailIdList} user={user} />
                </Dialog>
            </div>
        )
    }

    return (
        <div className='profile'>
            {ShareScreenDialog()}
            <h3 className='mb-3 ml-1'>My Profile</h3>
            <div className='col-12'>
                {userProfileDetails && (
                    <ContactInfo userProfilePhoto={userProfileDetails?.photo} user={user} contacts={userProfileDetails?.contacts} onRefresh={getUserProfileDetailsById} />
                )}

            </div>
            <div className="ml-1 pl-1 mt-4" style={{ overflow: 'auto' }}>
                <div style={{ float: 'left' }}>
                    <h3 >Profile Overview</h3>
                </div>
                <div style={{ float: 'right' }}>
                    <SplitButton label="Share" icon='pi pi-share-alt' onClick={() => onShow()} model={item} className="p-button-outlined mr-2 mb-2"></SplitButton>
                </div>
            </div>
            <div className='col-12'>
                <ProfileHeading userProfileDetails={userProfileDetails?.professionals} onRefresh={getUserProfileDetailsById} />
            </div>
            <div className='col-12'>
                <ProfileSkill userSkills={userProfileDetails?.skills} onRefresh={getUserProfileDetailsById} />
            </div>
            <div className='col-12'>
                <PrimarySkill userPrimarySkills={userProfileDetails?.primarySkills} userCommunicationSkillRating={userProfileDetails?.communicationRating} profileUserId={userProfileDetails?.id} onRefresh={getUserProfileDetailsById} />
            </div>

            <div className='col-12'>
                <ProfileProject userProjects={userProfileDetails?.projects} onRefresh={getUserProfileDetailsById} />
            </div>
            <div className='col-12'>
                <ProfileEducation userEducations={userProfileDetails?.educations} onRefresh={getUserProfileDetailsById} />
            </div>
            <div className='col-12'>
                <ProfileCertification userCertifications={userProfileDetails?.certificates} onRefresh={getUserProfileDetailsById} />
            </div>
        </div>
    )
}

export default Profile;